<template>
    <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="17"
            y="7.875"
            width="2.25"
            height="15"
            transform="rotate(90 17 7.875)"
            fill="#48E4FF"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
